import { createTheme } from "@mui/material";

export const rootTheme = {
  typography: {
    fontFamily: `'Manrope', sans-serif`,
    letterSpacing: 1.3,
    body1: {
      fontSize: 14
    },
    body2: {
      fontSize: 12
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          // filter: 'brightness(105%)',
          width: "100%"
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          borderRadius: 8,

        },
        paper: {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#003B6A',
          padding: 20
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          "&.Mui-selected": {
            backgroundColor: "#1976d2 !important",
            letterSpacing: 1,
            color: "#F8F8F8",
          },
        },
      }
    }
  },
};
export const appTheme = createTheme(rootTheme);
